export default __webpack_public_path__ + "static/4-2b68fecff0c4c139cf56117320f81cae.png";